import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../elements';

import styles from './listblob.scss';

class ListBlob extends Component {
  static propTypes = {
    onClick: PropTypes.func,
  };
  onClick = () => {
    const { onClick } = this.props;

    if (onClick) {
      onClick();
    }
  };

  render() {
    const { children } = this.props;

    return (
      <div className={styles.listblob} onClick={this.onClick}>
        { children }
        <Icon 
          className={styles.arrow} 
          color="gray"
          name="icon-right"
        />
      </div>
    );
  }
}

export { ListBlob };


// WEBPACK FOOTER //
// ./src/elements/listblob/listblob.js